module.exports = __webpack_public_path__ + "static/assets/ff611deb34bc9c097cb2ee3b16d35273.png";